import { createTheme } from "@mui/material/styles";

const loginTheme = createTheme({
  palette: {
    primary: {
      main: "#001f4c",
    },
    secondary: {
      main: "#6fdeb9",
      bg: "#e9f9f7",
    },
    text: { main: "white" },
    success: {
      main: "#66bb6a",
    },
    warning: {
      main: "#ffa726",
    },
    error: {
      main: "#f44336",
    },
  },
  typography: {
    fontFamily: "Montserrat, sans-serif", // Change the default font family
    title: {
      fontFamily: "Montserrat, sans-serif",
      fontSize: "48px",
      color: "white",
      paddingTop: "10px",
      paddingBottom: "10px",
      "@media (max-width:900px)": {
        fontSize: "32px",
        padding: "0",
      },
      "@media (max-width:600px)": {
        fontSize: "28px",
        padding: "0",
      },
    },
    subtitle: {
      fontFamily: "Montserrat, sans-serif",
      fontSize: "36px",
      color: "black",
      marginBottom: "15px",
    },
    subtitle2: {
      fontFamily: "Montserrat, sans-serif",
      fontSize: "30px",
      color: "black",
      marginBottom: "15px",
    },
    success: {
      fontFamily: "Montserrat, sans-serif",
      fontSize: "1rem",
      lineHeight: "1.5",
      color: "#66bb6a",
    },
    warning: {
      fontFamily: "Montserrat, sans-serif",
      fontSize: "1rem",
      lineHeight: "1.5",
      color: "#ffa726",
    },
    error: {
      fontFamily: "Montserrat, sans-serif",
      fontSize: "1rem",
      lineHeight: "1.5",
      color: "#f44336",
    },
  },
  components: {
    TextArea: {
      variants: [
        {
          props: { variant: "resizable" },
          style: { resize: "both" },
        },
      ],
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          position: "relative",
          overflow: "hidden",
          isolation: "isolate",
          background: "#001f4c",
          color: "#fff",

          "&::after": {
            content: '""',
            position: "absolute",
            inset: 0,
            background: "linear-gradient(180deg, #001f4c 0%, #6fdeb9 100%)",
            opacity: 0,
            transition: "opacity 0.2s ease",
            zIndex: -1,
          },

          "&:hover::after": {
            opacity: 1,
          },
        },

        outlined: {
          position: "relative",
          overflow: "hidden",
          isolation: "isolate",
          background: "#fff",
          color: "#001f4c",

          "&::after": {
            content: '""',
            position: "absolute",
            inset: 0,
            background: "linear-gradient(180deg, #fff 0%, #6fdeb9 100%)",
            opacity: 0,
            transition: "opacity 0.2s ease",
            zIndex: -1,
          },

          "&:hover::after": {
            opacity: 1,
          },
        },
      },
      variants: [
        {
          props: { variant: "login" },
          style: {
            position: "relative",
            overflow: "hidden",
            isolation: "isolate",

            fontFamily: "Montserrat, sans-serif",
            textTransform: "none",
            textAlign: "center",
            border: "2px solid white",
            color: "white",
            fontSize: "24px",
            margin: "10px",
            boxShadow: "5px 5px 5px rgba(0, 0, 0, 0.2)",

            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,
              background: "linear-gradient(180deg, #001f4c 0%, #6fdeb9 100%)",
              opacity: 0,
              transition: "opacity 0.2s ease",
              zIndex: -1,
            },

            "&:hover::before": {
              opacity: 1,
            },

            "@media (max-width:600px)": {
              fontSize: "16px",
              padding: "5px",
              margin: "0px",
            },
            "@media (max-width:900px)": {
              fontSize: "20px",
              padding: "5px",
              margin: "5px",
            },
          },
        },
        {
          props: { variant: "headerNav" },
          style: {
            position: "relative",
            overflow: "hidden",
            isolation: "isolate",

            fontFamily: "Montserrat, sans-serif",
            textTransform: "none",
            textAlign: "center",
            borderRadius: 0,
            color: "white",
            fontSize: "22px",

            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,
              background: "linear-gradient(180deg, #001f4c 0%, #6fdeb9 100%)",
              opacity: 0,
              transition: "opacity 0.2s ease",
              zIndex: -1,
            },

            "&:hover::before": {
              opacity: 1,
            },
            "@media (max-width:600px)": {
              fontSize: "16px",
              margin: "0px",
            },
            "@media (max-width:900px)": {
              fontSize: "20px",
              margin: "5px",
            },
          },
        },
        {
          props: { variant: "burgerNav" },
          style: {
            position: "relative",
            overflow: "hidden",
            isolation: "isolate",

            fontFamily: "Montserrat, sans-serif",
            textTransform: "none",
            textAlign: "center",
            borderRadius: 0,
            color: "white",
            fontSize: "20px",

            justifyContent: "flex-start",

            //background: "linear-gradient(90deg, #6fdeb9 0%, #001f4c 10%)",

            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,
              background: "linear-gradient(90deg, #6fdeb9 0%, #001f4c 100%)",
              opacity: 0,
              transition: "opacity 0.2s ease",
              zIndex: -1,
            },

            "&:hover::before": {
              opacity: 1,
            },
          },
        },
        {
          props: { variant: "text" },
          style: {
            fontFamily: "Montserrat, sans-serif",
            width: "fit-content",
            textTransform: "none",
            textAlign: "center",
            border: "2px solid white",
            color: "white",
            fontSize: "24px",
            ":hover": {
              backgroundColor: "#133765",
              //transform: "scale(1.1)",
              color: "white",
            },
          },
        },
        {
          props: { variant: "formSubmit" },
          style: {
            position: "relative",
            overflow: "hidden",
            isolation: "isolate",

            fontFamily: "Montserrat, sans-serif",
            width: "fit-content",
            textTransform: "none",
            color: "white",
            backgroundColor: "#001f4c",
            fontSize: "24px",

            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,
              background: "linear-gradient(180deg, #001f4c 0%, #6fdeb9 100%)",
              opacity: 0,
              transition: "opacity 0.2s ease",
              zIndex: -1,
            },

            "&:hover::before": {
              opacity: 1,
            },

            "&.Mui-disabled": {
              background: "#f3f3f3",
              color: "#dadada",
            },
          },
        },
      ],
    },
  },
});

export default loginTheme;
